import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import AuthoritySection from './components/AuthoritySection';
import ServicesSection from './components/ServicesSection';
import AIAnswerBlock from './components/AIAnswerBlock';
import ProcessSection from './components/ProcessSection';
import WhyChooseUs from './components/WhyChooseUs';
import ServiceAreas from './components/ServiceAreas';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';

export default function HomePage() {
  return (
    <div className="bg-obsidian font-sans">
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <AuthoritySection />
        <ServicesSection />
        <AIAnswerBlock />
        <ProcessSection />
        <WhyChooseUs />
        <ServiceAreas />
        <TestimonialsSection />
        <FAQSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
